import { Lock, RefreshCw } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { isExpiredUser } from "@/lib/plans";

// قفل الحساب المنتهي: يغلّف كل تبويب خدمي — «اشتراكي» و«الدعم» يبقيان مفتوحين ولا يُغلَّفان
export default function ExpiredGate({ onRenew, children }) {
  const { user } = useAuth();
  if (!isExpiredUser(user)) return children;

  return (
    <div className="bg-white rounded-2xl border shadow-sm p-10 text-center space-y-5"
      data-testid="expired-gate">
      <div className="w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto">
        <Lock className="w-8 h-8 text-amber-700" />
      </div>
      <div>
        <h2 className="text-lg font-extrabold text-emerald-950" data-testid="expired-gate-title">
          انتهى اشتراكك — جدد للاستمرار
        </h2>
        <p className="text-sm text-slate-500 leading-7 mt-2 max-w-md mx-auto">
          بياناتك وسجلاتك محفوظة بالكامل ولم يُحذف منها شيء. جدد اشتراكك الآن
          لتعود كل الخدمات للعمل فوراً كما كانت.
        </p>
      </div>
      <button onClick={onRenew} data-testid="expired-gate-renew"
        className="inline-flex items-center gap-2 bg-emerald-900 hover:bg-emerald-950 text-white rounded-xl px-6 py-3 text-sm font-bold transition-colors">
        <RefreshCw className="w-4 h-4" /> تجديد الاشتراك
      </button>
    </div>
  );
}
